'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollActive = void 0;
var $ = require("jquery");
var ScrollActive = /** @class */ (function () {
    function ScrollActive() {
        if ($('.bulletScrollActive').length) {
            // 初期化
            var observer_1 = new IntersectionObserver(this.pararax);
            $('.bulletScrollActive').each(function () {
                // 監視の開始
                observer_1.observe(this);
            });
        }
    }
    ScrollActive.prototype.pararax = function (entries, object) {
        entries.forEach(function (entry) {
            // 交差していない
            if (!entry.isIntersecting)
                return;
            // ターゲット要素
            var target = entry.target;
            target.dataset.scroll = '1';
            // 監視の解除
            object.unobserve(target);
        });
    };
    return ScrollActive;
}());
exports.ScrollActive = ScrollActive;
exports.default = ScrollActive;
